module.exports = __webpack_public_path__ + "static/media/item_13_6_comp.fb3833a4.png";